var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "offer-revision-form uk-form-stacked",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('h2', {
    staticClass: "uk-margin-medium"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'offer',
        params: {
          id: _vm.offer.id
        }
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.offer.name) + "\n    ")])], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.validity')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "uk-grid-small",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-1-4"
  }, [_c('date-time-picker', {
    attrs: {
      "label": _vm.$t('fields.validFrom'),
      "errors": _vm.fields.errors.validFrom,
      "max": _vm.fields.values.validUntil,
      "disabled": !_vm.isEditable,
      "placeholder": "∞"
    },
    model: {
      value: (_vm.fields.values.validFrom),
      callback: function($$v) {
        _vm.fields.values.validFrom = $$v
      },
      expression: "fields.values.validFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-4"
  }, [_c('date-time-picker', {
    attrs: {
      "label": _vm.$t('fields.validUntil'),
      "errors": _vm.fields.errors.validUntil,
      "min": _vm.fields.values.validFrom,
      "disabled": !_vm.isEditable,
      "placeholder": "∞"
    },
    model: {
      value: (_vm.fields.values.validUntil),
      callback: function($$v) {
        _vm.fields.values.validUntil = $$v
      },
      expression: "fields.values.validUntil"
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.prices')) + "\n    ")]), _vm._v(" "), _c('inheritance-toggle', {
    attrs: {
      "toggle-label": "Überschreiben",
      "overridden-default": []
    },
    model: {
      value: (_vm.fields.values.prices),
      callback: function($$v) {
        _vm.fields.values.prices = $$v
      },
      expression: "fields.values.prices"
    }
  }, [_c('price-manager', {
    attrs: {
      "errors": _vm.fields.errors.prices,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.prices),
      callback: function($$v) {
        _vm.fields.values.prices = $$v
      },
      expression: "fields.values.prices"
    }
  }), _vm._v(" "), _c('price-manager', {
    attrs: {
      "value": _vm.offer.prices,
      "has-controls": false
    },
    slot: "inherited"
  })], 1)], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.publications')) + "\n    ")]), _vm._v(" "), _c('inheritance-toggle', {
    attrs: {
      "toggle-label": "Überschreiben",
      "overridden-default": []
    },
    model: {
      value: (_vm.fields.values.publications),
      callback: function($$v) {
        _vm.fields.values.publications = $$v
      },
      expression: "fields.values.publications"
    }
  }, [_c('publication-manager', {
    attrs: {
      "errors": _vm.fields.errors.publications,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.publications),
      callback: function($$v) {
        _vm.fields.values.publications = $$v
      },
      expression: "fields.values.publications"
    }
  }), _vm._v(" "), _c('publication-manager', {
    attrs: {
      "value": _vm.offer.publications,
      "has-controls": false
    },
    slot: "inherited"
  })], 1)], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.details')))]), _vm._v(" "), _c('text-input', {
    staticClass: "uk-width-1-4",
    attrs: {
      "type": "number",
      "label": _vm.$t('fields.maxOrderableAmount'),
      "errors": _vm.fields.errors.maxOrderableAmount,
      "disabled": !_vm.isEditable,
      "placeholder": _vm.offer.maxOrderableAmount
    },
    model: {
      value: (_vm.fields.values.maxOrderableAmount),
      callback: function($$v) {
        _vm.fields.values.maxOrderableAmount = _vm._n($$v)
      },
      expression: "fields.values.maxOrderableAmount"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "label": _vm.$t('fields.usps'),
      "errors": _vm.fields.errors.usps,
      "disabled": !_vm.isEditable,
      "placeholder": _vm.offer.usps
    },
    model: {
      value: (_vm.fields.values.usps),
      callback: function($$v) {
        _vm.fields.values.usps = $$v
      },
      expression: "fields.values.usps"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "label": _vm.$t('fields.summaryTexts'),
      "errors": _vm.fields.errors.summaryTexts,
      "disabled": !_vm.isEditable,
      "placeholder": _vm.offer.summaryTexts
    },
    model: {
      value: (_vm.fields.values.summaryTexts),
      callback: function($$v) {
        _vm.fields.values.summaryTexts = $$v
      },
      expression: "fields.values.summaryTexts"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.media')) + "\n    ")]), _vm._v(" "), _c('attachment-manager', {
    attrs: {
      "attachment-type": "MEDIA_OBJECT",
      "errors": _vm.fields.errors.media,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.media),
      callback: function($$v) {
        _vm.fields.values.media = $$v
      },
      expression: "fields.values.media"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-medium-top"
  }, [_c('submit-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isSubmittable
    }
  }), _vm._v(" "), _c('cancel-button')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32874ed0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/OfferRevisionForm.vue
// module id = 1923
// module chunks = 0